import {
    APPLICANT_LEVEL_CERTIFICATE_CARD,
    APPLICANT_LEVEL_EDU_BASIC, APPLICANT_LEVEL_EDU_BASIC_PROF_DIPLOMA,
    APPLICANT_LEVEL_EDU_SECONDARY,
    APPLICANT_LEVEL_EDU_SPO,
    APPLICANT_LEVEL_EDU_VO
} from '../constants/diploma';

export const configDiploma = {
    [APPLICANT_LEVEL_EDU_BASIC]: 'Аттестат об основном общем образовании (9 классов)',
    [APPLICANT_LEVEL_EDU_SECONDARY]: 'Аттестат о среднем общем образовании (11 классов)',
    [APPLICANT_LEVEL_EDU_SPO]: 'Диплом о среднем профессиональном образовании',
    [APPLICANT_LEVEL_EDU_VO]: 'Диплом о высшем образовании',
    [APPLICANT_LEVEL_CERTIFICATE_CARD]: 'Справка/карточка',
    [APPLICANT_LEVEL_EDU_BASIC_PROF_DIPLOMA]: 'Диплом о начальном профессиональном образовании',
};

export const configDiplomaEn = {
    [APPLICANT_LEVEL_EDU_BASIC]: 'Certificate of Basic General Education (awarded after completing 9 grades)',
    [APPLICANT_LEVEL_EDU_SECONDARY]: 'Certificate of Secondary (Complete) General Education (awarded after completing 11 grades, allowing admission to higher education institutions)',
    [APPLICANT_LEVEL_EDU_SPO]: 'Diploma of Secondary Vocational Education (awarded after completing a technical school or college)',
    [APPLICANT_LEVEL_EDU_VO]: 'Bachelor’s/Specialist/Master’s Degree',
    [APPLICANT_LEVEL_CERTIFICATE_CARD]: 'Incomplete Education Certificate/ Certificate of Attendance',
    [APPLICANT_LEVEL_EDU_BASIC_PROF_DIPLOMA]: 'Vocational Training Diploma',
};
